import { createAction, props } from '@ngrx/store';
import { IGovernmentIdDataRequest, IGovernmentIdDataResponse } from '../models/governmentId.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

export const loadGovernmentIdRequest = createAction(
  '[GovernmentId] Load GovernmentId request',
  props<{ request: IGovernmentIdDataRequest }>()
);

export const loadGovernmentIdResponse = createAction(
  '[GovernmentId] Load GovernmentId Response',
  props<{ response: IGovernmentIdDataResponse }>()
);

export const loadGovernmentIdFailure = createAction(
  '[GovernmentId] Load GovernmentId Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
